import { StyleSheet } from 'react-native'

export const themedCalendarStripRenderDayStyles = StyleSheet.create({
	view: {
		width: '100%',
	}
})
